module.exports = __webpack_public_path__ + "static/img/shiming.1a181e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutsUs/shiming.png
// module id = cv4O
// module chunks = 1